/**
Copyright (C) 2019-2022, Infraclear Inc. All Rights Reserved.
*/

export const ErrorCodes = {
  SOFTWARE_TOKEN_MFA: 'SOFTWARE_TOKEN_MFA',
  SOFTWARE_TOKEN_TWOFA: 'SOFTWARE_TOKEN_TWOFA',
  NEW_PASSWORD_REQUIRED: 'NEW_PASSWORD_REQUIRED',
  MFA_SETUP: 'MFA_SETUP',
  INVALID_MFA_CODE: "INVALID_MFA_CODE",
  INVALID_TWOFA_CODE: "INVALID_TWOFA_CODE",
  INVALID_PARAMETER: "INVALID_PARAMETER",
  UNAUTHORIZED_ACTION: "UNAUTHORIZED_ACTION",
  MFA_SECRET_EXPIRED: "MFA_SECRET_EXPIRED",
  DUPLICATE_USERNAME: 'DUPLICATE_EMAIL',
  INVALID_SECRET_CODE: "Invalid secret code",
  INVALID_USERNAME_PASSWORD: "INVALID_USERNAME_PASSWORD",
  INVALID_CODE_FORGOT: "INVALID_CODE",
  LIMIT_EXCEED_FORGOT: "LIMIT_EXCEED",
  INVALID_EMAIL: "INVALID_EMAIL",
  USER_ALREADY_EXIST: "USER_ALREADY_EXIST",
  INVALID_SECRET: "INVALID_SECRET",
  USER_EXPIRED: "USER_EXPIRED",
  PAYG_TRIAL_CREDIT_EXHAUSTED: "PAYG_TRIAL_CREDIT_EXHAUSTED",
  INTERNAL_SERVER_ERROR: "INTERNAL_SERVER_ERROR",
  TEMP_PASSWORD_EXPIRED: "TEMP_PASSWORD_EXPIRED",
  INVALID_GUEST_QR: "INVALID_GUEST_QR",
  INVALID_DEVICE: "INVALID_DEVICE",
  INVALID_GUEST_URL: "INVALID_GUEST_URL",
  MFA_NOT_SUPPORTED: "MFA_NOT_SUPPORTED",
  INVALID_USER_STATUS_FOR_PWD_RESET: "INVALID_USER_STATUS_FOR_PWD_RESET",
  INVALID_ROLE_CHANGE: "INVALID_ROLE_CHANGE",
  ERROR_INVALID_ATTEMPTS: "ERROR_INVALID_ATTEMPTS",
  ERROR_ACCOUNT_DISABLED: "ERROR_ACCOUNT_DISABLED",
  PAYG_INVALID_SUBSCRIPTION : 'PAYG_INVALID_SUBSCRIPTION',
  SSO_TOKEN_AUTH_EXPIRED: 'SSO_TOKEN_AUTH_EXPIRED',
  SSO_LOGIN_USER_LIMIT_REACHED: 'SSO_LOGIN_USER_LIMIT_REACHED',
  BULKDATA_API_USER_NOT_AUTHORIZED: 'BULKDATA_API_USER_NOT_AUTHORIZED',
  SUBSCRIPTION_DEACTIVATED: 'subscription.deactivated',
  DEACTIVATION_AT_END_REQUESTED: 'DEACTIVATION_AT_END_REQUESTED',
  SUBSCRIPTION_DEACTIVATION_ALREADY_REQUESTED: 'SUBSCRIPTION_DEACTIVATION_ALREADY_REQUESTED',
  SUBSCRIPTION_CANCELLATION_FAILED: 'SUBSCRIPTION_CANCELLATION_FAILED',
};